






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { ButtonType } from '@/data/enums'

@Component({})
export default class DefaultButton extends Vue {
  @Prop({ default: ButtonType.Default }) public type!: ButtonType
  private buttonType: object = ButtonType
}
